import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Route, Redirect, withRouter } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

/** Lê tokens de sessão backend uma vez (bootstrap), antes de redux-persist reidratar. */
function readBackendSessionFromPersistOnce() {
  try {
    const root = localStorage.getItem("persist:root");
    if (!root) return false;
    const parsed = JSON.parse(root);
    const auth = parsed.auth ? JSON.parse(parsed.auth) : null;
    return Boolean(auth?.backendAccessToken ?? auth?.accessToken);
  } catch {
    return false;
  }
}

function Private({ children, location }) {
  const rehydrated = useSelector((state) => state._persist?.rehydrated === true);
  const hasBackendFromStore = useSelector((state) =>
    Boolean(state.auth?.backendAccessToken ?? state.auth?.accessToken)
  );

  const [preHydrateBackendSession] = useState(readBackendSessionFromPersistOnce);

  const hasBackendSession = rehydrated
    ? hasBackendFromStore
    : preHydrateBackendSession;

  const isAuthenticated = useIsAuthenticated() || hasBackendSession;
  const { inProgress } = useMsal();

  if (inProgress !== "none") {
    return null;
  }

  return isAuthenticated ? (
    <Route render={(props) => React.cloneElement(children, props)} />
  ) : (
    <Redirect
      to={{
        pathname: "/",
        state: { from: location },
      }}
    />
  );
}

export default withRouter(Private);
